import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const onlineUserRoutes: RouteObject[] = [
  {
    path: '/online-user/search',
    element: lazyElement(() => import('./Search')),
    handle: {
      documentTitle: 'Online User Search',
      crumb: () => ({ label: 'Online Users', to: '/online-user/search' }),
    },
  },
  {
    path: '/online-user/view/:id',
    element: lazyElement(() => import('./View')),
    handle: { crumb: () => ({ label: 'Online User' }) },
  },
];

export default onlineUserRoutes;
